/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realtime_Unavailable_Description_No_DataInputs */



/**
* | output |
* | --- |
* | "No recent data. Live display is momentarily unavailable." |
*
* @param {Realtime_Unavailable_Description_No_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const realtime_unavailable_description_no_data = /** @type {((inputs?: Realtime_Unavailable_Description_No_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realtime_Unavailable_Description_No_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No recent data.\nLive display is momentarily unavailable.")
	return /** @type {LocalizedString} */ ("Aucune donnée récente.\nL'affichage en direct est momentanément indisponible.")
});